'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = WeveGotYouCovered;

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _benefits_icon_ = require('../assets/benefits_icons/benefits_icon_1.png');

var _benefits_icon_2 = _interopRequireDefault(_benefits_icon_);

var _benefits_icon_3 = require('../assets/benefits_icons/benefits_icon_2.png');

var _benefits_icon_4 = _interopRequireDefault(_benefits_icon_3);

var _benefits_icon_5 = require('../assets/benefits_icons/benefits_icon_3.png');

var _benefits_icon_6 = _interopRequireDefault(_benefits_icon_5);

var _benefits_icon_7 = require('../assets/benefits_icons/benefits_icon_4.png');

var _benefits_icon_8 = _interopRequireDefault(_benefits_icon_7);

var _benefits_icon_9 = require('../assets/benefits_icons/benefits_icon_5.png');

var _benefits_icon_10 = _interopRequireDefault(_benefits_icon_9);

var _benefits_icon_11 = require('../assets/benefits_icons/benefits_icon_6.png');

var _benefits_icon_12 = _interopRequireDefault(_benefits_icon_11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function WeveGotYouCovered() {
    return _react2['default'].createElement(
        'div',
        { className: 'm-careers-page--weve-got-you-covered row' },
        _react2['default'].createElement(
            'div',
            { className: 'm-careers-page--weve-got-you-covered--intro columns small-12 medium-4' },
            _react2['default'].createElement(
                'h2',
                null,
                'We\'ve got you covered'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign takes employee happiness and well-being very seriously. We offer perks beyond basic benefits (though we cover those, too!) and do everything we can to make our team feel awesome.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Here\u2019s a peek into what you can expect from your first day on.'
            )
        ),
        _react2['default'].createElement(
            'div',
            { className: 'columns small-12 medium-6 medium-offset-2 end' },
            _react2['default'].createElement(
                'h3',
                null,
                'STELLAR BENEFITS'
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-careers-page-weve-got-you-covered--benefit' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-careers-page-weve-got-you-covered--benefit--image' },
                    _react2['default'].createElement('img', { src: _benefits_icon_2['default'] })
                ),
                _react2['default'].createElement(
                    'h4',
                    null,
                    'The Basics'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'We pay 100% of team member\u2019s medical, dental, and vision insurance premiums and also cover 50% for your dependents. We offer pre-tax commuter benefits and a 401(k) plan, which even includes financial planning services.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-careers-page-weve-got-you-covered--benefit' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-careers-page-weve-got-you-covered--benefit--image' },
                    _react2['default'].createElement('img', { src: _benefits_icon_4['default'] })
                ),
                _react2['default'].createElement(
                    'h4',
                    null,
                    'Flexible Scheduling'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Flexible vacation days, generous paid holidays, and the occasional work from home (or cafe or park) day. You can partner with your team to balance life, work and what drives your productivity.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-careers-page-weve-got-you-covered--benefit' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-careers-page-weve-got-you-covered--benefit--image competitive-salary' },
                    _react2['default'].createElement('img', { src: _benefits_icon_6['default'] })
                ),
                _react2['default'].createElement(
                    'h4',
                    null,
                    'Competitive Salary'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Every team member is paid a competitive salary and offered a generous stock option plan. You have the opportunity to literally own a part of what we\u2019re building together.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-careers-page-weve-got-you-covered--benefit' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-careers-page-weve-got-you-covered--benefit--image culture-of-learning' },
                    _react2['default'].createElement('img', { src: _benefits_icon_8['default'] })
                ),
                _react2['default'].createElement(
                    'h4',
                    null,
                    'A Culture of Learning'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Between our catered lunch & learns, guest speakers, blameless post-mortems, cross-department squads and many other new initiatives we\u2019re working on, we take a deliberate approach to empowering our team\u2019s constant learning.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-careers-page-weve-got-you-covered--benefit' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-careers-page-weve-got-you-covered--benefit--image' },
                    _react2['default'].createElement('img', { src: _benefits_icon_10['default'] })
                ),
                _react2['default'].createElement(
                    'h4',
                    null,
                    'Dogs'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'We are simply dog lovers so pups, large and small, frequent the office. Some even have their own HipChat emoticons!  Need we say more?'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-careers-page-weve-got-you-covered--benefit' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-careers-page-weve-got-you-covered--benefit--image' },
                    _react2['default'].createElement('img', { src: _benefits_icon_12['default'] })
                ),
                _react2['default'].createElement(
                    'h4',
                    null,
                    'HelloSign Community'
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Our team is encouraged to kick-off their own HelloSign team events like our running club, volunteer events, spring & holiday potlucks, game nights, ping-pong tournaments. Moms, dads, kids, friends and significant others frequently drop by and are considered our extended HelloSign family!'
                )
            )
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/careers-page/weve-got-you-covered/index.jsx
 ** module id = 1584
 ** module chunks = 0
 **/